/**
 * Who gets the owner's page for an invention. Anyone who can read an invention but does not own
 * it (a disclosure recipient, a collaborator) belongs on the read-only shared view; owners,
 * portfolio (aggregator) readers and platform admins keep the page they already had.
 */
export function shouldUseSharedView(args: {
  projectId?: string
  hasProject: boolean
  userId?: string
  isOwner: boolean
  hasAggregatorAccess: boolean
  isPlatformAdmin: boolean
}): boolean {
  return !!args.projectId && args.hasProject && !!args.userId && !args.isOwner && !args.hasAggregatorAccess && !args.isPlatformAdmin
}
